export enum ENV_OPTIONS {
  DEV = 'DEV',
  QA = 'QA',
  AQA = 'AQA',
  PROD = 'PROD',
}

export interface Environment {
  sentry: {
    dsn: string | undefined;
    release: string | undefined;
    enabled: boolean;
    sentryEnv: string | undefined;
  };
  fullStory: {
    orgId: string | undefined;
    isDevMode: boolean;
  };
  nodeEnv: string | undefined;
  currentEnv: ENV_OPTIONS;
  publicUrl: string;
  publicServerDomain: string;
  publicServerUrlPrefix: string;
  localDevServerDomain: string | null | undefined;
  makeRequestTimeoutInMs: number;
  analyticsDevMode: boolean;

  mixPanelToken?: string;
  verizonPieUrl: string | undefined;
  widgetServicesBaseUrl?: string;
  eventIngestionPipelineKey?: string | undefined;
  eventIngestionPipelineUrl?: string | undefined;
}
